import React, { useState } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../_metronic/_partials/controls";
import * as apiRag from "../../api/rag";

export function SyncPage() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const user = useSelector((state) => state.auth.user, shallowEqual);

  const handleSync = async () => {
    setLoading(true);
    setResult(null);
    setError(null);
    try {
      const response = await apiRag.syncEvents(user.authToken);
      setResult(response);
    } catch (err) {
      setError(err.message || "Errore durante la sincronizzazione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader title="Sincronizzazione RAG">
        <CardHeaderToolbar>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row">
          <div className="col-lg-12">
            <p>
              Clicca il pulsante sottostante per sincronizzare gli eventi del calendario nel database vettoriale (MariaDB Vector).
              Questa operazione genererà gli embedding per gli eventi futuri e li salverà per la ricerca semantica.
            </p>
            <button 
              className="btn btn-primary" 
              onClick={handleSync} 
              disabled={loading}
            >
              {loading ? "Sincronizzazione in corso..." : "Sincronizza Eventi"}
            </button>
          </div>
        </div>

        {result && (
          <div className="alert alert-success mt-4">
            <h4 className="alert-heading">Sincronizzazione Completata!</h4>
            <p>Eventi elaborati: {result.processed}</p>
            {/* Show raw result for debug if needed */}
            <pre className="mt-2">{JSON.stringify(result, null, 2)}</pre>
          </div>
        )}

        {error && (
          <div className="alert alert-danger mt-4">
            <h4 className="alert-heading">Errore</h4>
            <p>{error}</p>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
